import styled from "styled-components"

export interface HalfDoughnutSummaryItem {
  label: string
  color: string
  value: number
}

export const WidgetValueWrapper = styled.div<{ $inline?: boolean }>`
  margin-top: ${({ $inline }) => ($inline ? "0" : "4px")};
  font-size: ${({ $inline }) => ($inline ? "14px" : "24px")};
  font-weight: 500;
  line-height: 1.5;
  color: ${({ $inline }) => ($inline ? "#0f172a" : "inherit")};
`

export const ValueWithPercentage = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
  font-size: 16px;

  .percentage {
    font-size: 14px;
    font-weight: 300;
    color: #475569;
  }
`

export const WidgetNote = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;

  &::before {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    display: inline-flex;
    margin-right: 4px;
    content: "";
    background-color: ${({ $color }) => $color};
  }
`
